import type { Element, Node } from 'react'
import React from 'react'
import type { BreadcrumbElement } from 'app/common/breadcrumb'
import { media } from 'app/assets/styles'
import styled from 'styled-components'
import { HeadTitle } from 'app/common/head-title'

type Props = {
    title: string,
    breadcrumb?: Array<BreadcrumbElement>,
    url?: string,
    description?: string,
    children?: Node,
    icon?: Element<any>,
    className?: string,
    blazonProfileImageUrl?: string
}

const MenuItem = (props: Props) => {
    const { children, ...head } = props

    return (
        <MenuContent>
            <HeadTitle {...head} />
            {children}
        </MenuContent>
    )
}

const MenuContent = styled.div`
    min-height: 400px;
    ${media.medium`
        text-align: left;
        width: 100%;
        margin-left: 128px;
        margin-top: 50px;
    `};
    ${media.large`
        width: 956px;
    `};
`

export { MenuItem }
